import Avatar, {AvatarSize} from '@/components/Avatar';
import styles from './index.module.scss';
import toast, {ToastType, toastObjects} from '@/components/Toast';
import GiveCoinImg from '@/assets/img/knowledgeCoinGiveSuccess.png';
import ThanksCoinIcon from '@/assets/img/docCoin.gif';
import routers, {buildPath} from '@/config/routers';
import {clickGiveCoinTextMoreGiveCoin} from '@/buried/home';
import {MouseEventHandler, useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import {FindTabs} from '@/Constant';
import ShareDoc, {IDocShareInfo} from '../ShareDoc';

export enum SENT_COIN_SUCCESS_STATUS {
    nothing = 0,
    one = 1,
    two = 2
}

interface ThanksForTheCoinProps {
    history:any;
    creatorGuid: string;
    creatorName: string;
    sentence: string | null;
    docShare: IDocShareInfo;
}


function ThanksForRandomPrizing(props: {
    sentence: string;
}) {
    const {sentence} = props;
    return <div className={styles.giftContainer}>
        <span className={styles.iconLine}>
            <img className={styles.icon} src={ThanksCoinIcon}></img>
            <span className={styles.giftTextStatic}>额外奖励</span>
            <span className={styles.giftText}>{sentence}</span>
        </span>
    </div>;
}

const moreArticle = buildPath(routers.FindPage, {tab: FindTabs.highQuality});
const ThanksForNoGift:React.FC<ThanksForTheCoinProps> = ({history, creatorGuid, creatorName, sentence, docShare}) => {


    const handleFindMoreArticleLogger:MouseEventHandler<HTMLAnchorElement> = (e) => {
        clickGiveCoinTextMoreGiveCoin();
        window.open(moreArticle);
        toastObjects[ToastType.Info]?.remove();
    };

    const handleCloseToast = useCallback(() => {
        toastObjects[ToastType.Info]?.remove();
    }, []);

    return <>
        <div className={styles.thanksToast}>
            {/* <div>
                <img className={styles.giveCoinImg} src={GiveCoinImg} alt="投币成功" />
            </div> */}
            <span className={styles.giveCoinSuccess}>赠币成功</span>
            <span className={styles.commonText}>
                <Avatar className={styles.avatar} userGuid={creatorGuid} size={AvatarSize.SM} />
                <span className={styles.creator}>{creatorName} </span>
                已收到你的认可
            </span>
            <p className={styles.linkToMore}>
                <span onClick={handleFindMoreArticleLogger}>发现更多好文</span>
            </p>
            {sentence && <ThanksForRandomPrizing sentence={sentence} />}
        </div>
        {/* <ShareDoc
            className={styles.shareDoc}
            onCloseMysteryBoxDialog={handleCloseToast}
            docShareInfo={docShare}
        /> */}
    </>;
};
const ThanksSentense = (
    toastDate: {
        status: SENT_COIN_SUCCESS_STATUS;
        creatorGuid: string;
        creatorName: string;
        docShare: IDocShareInfo;
    }, history:any
) => {

    const {status, creatorGuid, creatorName, docShare} = toastDate;
    const strategy = {
        [SENT_COIN_SUCCESS_STATUS.nothing]: null,
        [SENT_COIN_SUCCESS_STATUS.one]: '1枚可用知识币~',
        [SENT_COIN_SUCCESS_STATUS.two]: '2枚可用知识币~',
    };
    toast({
        className: styles.toast,
        content: <ThanksForNoGift
            creatorGuid={creatorGuid}
            creatorName={creatorName}
            sentence={strategy[status]}
            history={history}
            docShare={docShare}
        />,
        manualClose: true,
        duration: 5000,
        type: ToastType.Info,
    });
};

export default ThanksSentense;
